type GetIsSiteAdminFromQueryParam = {
	readonly isSiteAdmin?: boolean | null;
} | null;

export const getIsSiteAdminFromQuery = (queryData?: GetIsSiteAdminFromQueryParam): boolean =>
	Boolean(queryData?.isSiteAdmin);
